/* tslint:disable:no-bitwise */
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AuthService } from '../services.module/auth.service';

import { Menupoint } from '../model.module/menupoint.model';
import { Permission } from '../model.module/constant/rights.enum';

import { RouteNames } from '../route.name';
import { ConfigurationApiService } from '../../generated/api/configuration/configuration.service';
import { ConfigurationData } from '../../generated/api/kreditportalBackendAPI.schemas';

@Injectable({ providedIn: 'root' })
export class MenuService {

    private static readonly menu: Menupoint[] = [
        {
            name: 'cockpit',
            label: 'Cockpit',
            targetUri: RouteNames.KREDIT_PORTAL_COCKPIT,
            requiredRights: Permission.READ_COCKPIT,
            alternatives: ['kundenauswahl'],
            icon: 'cockpit',
            children: [],
        },
        {
            name: 'posteingang',
            label: 'Posteingang',
            targetUri: RouteNames.KREDIT_PORTAL_POSTEINGANG,
            requiredRights: Permission.READ_POSTEINGANG,
            alternatives: [],
            icon: 'inbox_mail',
            children: [],
        },
        {
            name: 'kundenauswahl',
            label: 'Kunden',
            targetUri: RouteNames.KREDIT_PORTAL_KUNDENAUSWAHL,
            requiredRights: Permission.BE_MAKLER_OR_STBR,
            icon: 'contract',
            alternatives: ['meine_daten'],
            children: [
                {
                    name: 'freigeschaltet',
                    label: 'freigeschaltet',
                    targetUri: RouteNames.FREI,
                    requiredRights: Permission.BE_MAKLER_OR_STBR | Permission.BE_MAKLER,
                    alternatives: ['meine_daten'],
                    children: [],
                },
                {
                    name: 'nicht-freigeschaltet',
                    label: 'nicht freigeschaltet',
                    targetUri: 'unfrei',
                    requiredRights: Permission.BE_MAKLER_OR_STBR | Permission.BE_MAKLER,
                    alternatives: ['meine_daten'],
                    children: [],
                },
            ],
        },

        {
            name: 'vertraege',
            label: 'Kautionsverträge',
            targetUri: RouteNames.KREDIT_PORTAL_VERTRAEGE,
            requiredRights: Permission.READ_KAUTION_CONTRACTS,
            alternatives: [],
            icon: 'contract',
            children: [],
        },
        {
            name: 'buergschaften',
            label: 'Bürgschaften',
            targetUri: RouteNames.KREDIT_PORTAL_BUERGSCHAFTEN,
            requiredRights: Permission.READ_BUERGSCHEINE,
            alternatives: [],
            icon: 'guarantee',
            children: [
                {
                    name: 'obligo',
                    label: 'Obligolisten',
                    targetUri: 'obligo',
                    requiredRights: Permission.READ_OBLIGO,
                    alternatives: [],
                    children: [],
                },
                {
                    name: 'create-buergschein',
                    label: 'Bürgschaft beantragen',
                    targetUri: 'create-buergschein',
                    requiredRights: Permission.READ_CREATE_BS,
                    alternatives: [],
                    children: [],
                },
            ],
        },
        {
            name: 'downloads',
            label: 'Downloads',
            targetUri: RouteNames.KREDIT_PORTAL_DOWNLOADS,
            requiredRights: Permission.READ_DOWNLOADS,
            alternatives: [],
            icon: 'download',
            children: [],
        },
        {
            name: 'benutzerverwaltung',
            label: 'Benutzer',
            targetUri: RouteNames.KREDIT_PORTAL_BENUTZERVERWALTUNG,
            requiredRights: Permission.READ_BENUTZERVERWALTUNG,
            alternatives: [],
            children: [],
        },
        {
            name: 'meine_daten_vm',
            label: 'Meine Daten',
            targetUri: RouteNames.KREDIT_PORTAL_MYDATA,
            requiredRights: Permission.BE_MAKLER_OR_STBR | Permission.READ_VERMITTLERDATEN,
            alternatives: ['meine_daten'],
            icon: 'data',
            children: [],
            hidden: true,
        },
        {
            name: 'meine_daten',
            label: 'Meine Daten',
            targetUri: RouteNames.KREDIT_PORTAL_MEINEDATEN,
            requiredRights: Permission.READ_MEINE_DATEN,
            alternatives: [],
            icon: 'data',
            children: [
                {
                    name: 'profile',
                    label: 'Profil',
                    targetUri: 'profil',
                    requiredRights: Permission.READ_MEINE_DATEN | Permission.READ_MEINE_DATEN_PROFIL,
                    alternatives: [],
                    children: [],
                },
                {
                    name: 'annualReport',
                    label: 'Jahresabschluss',
                    targetUri: 'jahresabschluss',
                    requiredRights: Permission.READ_MEINE_DATEN | Permission.READ_MEINE_DATEN_JAHRESABSCHLUSS,
                    alternatives: [],
                    children: [],
                },
                {
                    name: 'maklerMandat',
                    label: 'Maklermandat',
                    targetUri: 'maklermandat',
                    requiredRights: Permission.READ_MEINE_DATEN | Permission.READ_MEINE_DATEN_MAKLERMANDAT,
                    alternatives: [],
                    children: [],
                },
            ],
        },

        {
            name: 'firmenverbuende',
            label: 'Firmenverbünde',
            targetUri: RouteNames.KREDIT_PORTAL_FIRMENVERBUENDE,
            requiredRights: Permission.READ_FIRMENVERBUENDE,
            alternatives: [],
            icon: 'contract',
            children: [
                {
                    name: 'erhalteneZugriffe',
                    label: 'Erhaltene Zugriffe',
                    targetUri: 'erhalteneZugriffe',
                    requiredRights: Permission.READ_FIRMENVERBUENDE,
                    alternatives: [],
                    children: [],
                },
                {
                    name: 'zugriffeVerwalten',
                    label: 'Zugriffe verwalten',
                    targetUri: 'zugriffeVerwalten',
                    requiredRights: Permission.READ_FIRMENVERBUENDE,
                    alternatives: [],
                    children: [],
                },
            ],
        },

        {
            name: 'kundendaten',
            label: 'Kundendaten',
            targetUri: RouteNames.KREDIT_PORTAL_KUNDENDATEN,
            requiredRights: Permission.READ_FOREIGN_DATEN,
            alternatives: [],
            icon: 'data',
            children: [
                {
                    name: 'profile',
                    label: 'Profil',
                    targetUri: 'profil',
                    requiredRights: Permission.READ_FOREIGN_DATEN | Permission.READ_FOREIGN_DATEN_PROFIL,
                    alternatives: [],
                    children: [],
                },
                {
                    name: 'annualReport',
                    label: 'Jahresabschluss',
                    targetUri: 'jahresabschluss',
                    requiredRights: Permission.READ_FOREIGN_DATEN | Permission.READ_FOREIGN_DATEN_JAHRESABSCHLUSS,
                    alternatives: [],
                    children: [],
                },
            ],
        },
    ];

    constructor(
        private readonly authService: AuthService,
        private readonly configurationApiService: ConfigurationApiService,
    ) {
    }

    isAccessible(menuPoint: Menupoint, rights: number): boolean {
        return (menuPoint.requiredRights & rights) === menuPoint.requiredRights;
    }

    filterMenupoints(menuPoints: Menupoint[], rights: number) {
        const tmp = menuPoints.filter((mp) =>
            this.isAccessible(mp, rights),
        );

        for (const mp of tmp) {
            if (mp.children.length !== 0) {
                mp.children = this.filterMenupoints(mp.children, rights);
            }
        }

        return tmp;
    }

    findMenupointOrNull(path: string, menuPoints: Menupoint[] = null): Menupoint {
        const mp = menuPoints || MenuService.menu;

        for (const m of mp) {
            if (path.indexOf(m.targetUri) !== 1) {
                continue;
            }

            // Now look, if a child matches (women and children first).
            if (m.children && m.children.length !== 0) {
                const nMp = this.findMenupointOrNull(path, m.children);
                if (nMp) {
                    return nMp;
                }
            }

            return m;
        }

        return null;
    }

    findAlternativeForOrNull(menupoint: Menupoint, rights: number): Menupoint {
        let myIndex = 0;
        for (let i = 0; i < MenuService.menu.length; i++) {
            if (MenuService.menu[i] === menupoint) {
                myIndex = i;
                break;
            }
        }

        for (let i = myIndex + 1; i < MenuService.menu.length; i++) {
            if (this.isAccessible(MenuService.menu[i], rights)) {
                return MenuService.menu[i];
            }
        }

        for (let i = 0; i < myIndex; i++) {
            if (this.isAccessible(MenuService.menu[i], rights)) {
                return MenuService.menu[i];
            }
        }

        return null;
    }

    getMenupoints(): Observable<Menupoint[]> {
        return this.loadHilfeMenupoint().pipe(
            map(hilfe => this.buildMenupoints(hilfe)),
        );
    }

    private loadHilfeMenupoint(): Observable<Menupoint | null> {
        return this.configurationApiService.getConfiguration().pipe(
            map(configuration => this.getHilfeMenupoint(configuration)),
            catchError(error => {
                console.debug('Hilfe-Konfiguration konnte nicht abgerufen werden.', error);
                return of(null);
            }),
        );
    }

    // Reine Transformation ohne Seiteneffekte: baut das Menü auf einem frischen Clone auf
    private buildMenupoints(hilfe: Menupoint | null): Menupoint[] {
        const menu = this.cloneMenu();

        if (hilfe) {
            menu.push(hilfe);
        }

        const filtered = this.filterMenupoints(menu, this.authService.getRole());
        return this.filterFirmenverbuendeWennEingesprungen(filtered);
    }

    // Nach Einspringen in einen Firmenverbund-Partner ("In Account einspringen"/Mandatsansicht) darf der
    // Firmenverbund-Menüpunkt nicht mehr angezeigt werden.
    private filterFirmenverbuendeWennEingesprungen(menupoints: Menupoint[]): Menupoint[] {
        if (!this.authService.getActiveKunde()?.$_clientOfFirmenverbund) {
            return menupoints;
        }

        return menupoints.filter(mp => mp.name !== 'firmenverbuende');
    }

    // Hilfe-Element liefern, damit danach das Menü neu gefiltert wird
    getHilfeMenupoint(configuration: ConfigurationData): Menupoint {
        const mp = new Menupoint();
        mp.name = 'hilfe';
        mp.label = 'Hilfe';
        mp.icon = 'help-sidebar';
        mp.children = [];
        mp.targetUri = configuration.urlInterneHilfe;
        mp.requiredRights = Permission.READ_HILFE;
        mp.alternatives = [];

        return mp;
    }


    private cloneMenu(): Menupoint[] {
        return JSON.parse(JSON.stringify(MenuService.menu));
    }

}
